export const INTERVIEW_INVITE_OPTIONS = {
    INVITE_CANDIDATE: 'Invite candidate',
    MARK_AS_INVITED: 'Mark as invited',
};
